import CheckoutBanner from "../components/Cart/CheckoutBanner";
import CheckoutCourses from "../components/Cart/CheckoutCourses";
export default function CheckoutPage() {
  return (
    <>
      <CheckoutBanner />
      <CheckoutCourses />
    </>
  );
}
